<div class="main-container">
  <h2 mat-dialog-title>{{'TERMS_AND_CONDITIONS' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
    {{ data.message | translate }}
  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="end">
    <rezolve-secondary-button mat-dialog-close>OK</rezolve-secondary-button>
  </mat-dialog-actions>
</div>